import { forwardRef, useRef, useImperativeHandle } from 'react';

import {
    Layout as PropsLayout,
    Selector as PropsSelector,
    LayoutSystem as PropsLayoutSystem,
} from '@/models/Props';

import useSetProperties from '@/helpers/useSetProperties';

import './LGridSystem.scss';

const LGridSystem = forwardRef(
    (
        {
            section,
            children,
            ariaLabel,
            className,
            sortChildren,
            gap,
            positioning,
            dataAttb,
        }: PropsLayout & PropsSelector & PropsLayoutSystem,
        ref
    ) => {
        // Custom tag for SEO and accessibility
        const Tag = section ? 'section' : 'div';
        const tagRef = useRef<any>(null);

        useImperativeHandle(ref, () => tagRef.current);

        /* To have control over the properties that can be 
        used to customize the layout */
        const customProperties: any = {
            gap: gap ? `${gap}rem` : '',
            'align-items': positioning?.alignItems
                ? positioning.alignItems
                : 'normal',
            'justify-items': positioning?.justifyItems
                ? positioning.justifyItems
                : 'legacy',
            'align-content': positioning?.alignContent
                ? positioning.alignContent
                : 'normal',
            'justify-content': positioning?.justifyContent
                ? positioning.justifyContent
                : 'normal',
        };

        /* From `customProperties`, the hook will transform a 
        `string property` into a `custom property` */
        useSetProperties(customProperties, tagRef);

        return (
            <Tag
                ref={tagRef}
                aria-label={ariaLabel}
                data-grid={'active'}
                data-grid-dir={sortChildren}
                className={className ? `${className}` : ''}
                {...dataAttb}
            >
                {children}
            </Tag>
        );
    }
);

export default LGridSystem;
